import { Image, SVGImage } from '@leshen/gatsby-theme-leshen'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

const determineImage = ({
  svg,
  cloudinary,
  contentful,
  aspectRatio,
  borderRadius,
  customPosition,
  useGatsbyImage,
  alt,
}) => {
  const ImageComponent = null
  if (svg) {
    return (
      <SVGImage
        svg={svg?.code}
        presentationWidth={svg?.presentationWidth}
        alt={alt || svg?.description}
      />
    )
  }

  if (contentful) {
    const imgType = contentful?.media?.file?.contentType

    if (useGatsbyImage) {
      return <GatsbyImage image={contentful} alt={alt} />
    }

    if (imgType === 'image/svg+xml') {
      return (
        <SVGImage
          url={`https:${contentful?.media?.file?.url}`}
          description={contentful?.media?.description}
          alt={alt}
        />
      )
    }

    return (
      <Image
        data={getImage(contentful?.media)}
        borderRadius={borderRadius}
        customPosition={customPosition}
        aspectRatio={aspectRatio}
        alt={alt}
      />
    )
  }

  if (cloudinary) {
    return (
      <Image
        data={cloudinary}
        borderRadius={borderRadius}
        customPosition={customPosition}
        aspectRatio={aspectRatio}
        alt={alt}
      />
    )
  }

  return ImageComponent
}

export default determineImage
